<!--<ara-side-nav class="inside-topnav" [routesFlag]="routesFlag" [reportRoutes]="reportRoutes"></ara-side-nav>-->

<form [formGroup]="CSForm" #csForm="ngForm">
  <div class="page-content-wrapper">
    <div class="col-lg-12 col-md-12 col-sm-12 mobile-view">
      <ol class="breadcrumb bc-3"  >
        <li>
        <a [routerLink]="'/home'">Home</a>
        </li>
        <li>
        <a>Performance Dashboard</a>
        </li>
        </ol>
        <div class="inner-wrapper">
        <div class="sub-wrapper">
          <h3 class="page-title obs-card-title" style="text-align: center">
            <span class="page-sub-title">
              <ng-container *ngIf="isUpdate">CONTRACTOR STATISTICS : CS{{statisticId}}
              </ng-container>
              <ng-container *ngIf="!isUpdate">CONTRACTOR STATISTICS
              </ng-container>
          </span><button *ngIf="isUpdate" (click)="onNextClick()" [ngClass]="isNext ? 'cursor-pointer':'disabled'" class="pull-right btn btn-primary primary-btn">
            <i class="fa fa-angle-right"></i>
          </button>
            <button *ngIf="isUpdate" (click)="onPreviousClick()"  [ngClass]="isPrevious ? 'cursor-pointer':'disabled'"  class="pull-right btn btn-primary primary-btn">
              <i class="fa fa-angle-left"></i></button>
          </h3>
          <div class="section-wrapper right">
            <span class="mandatory-info">
              Fields marked with<span class="mandatory">*</span>
               are mandatory
            </span>
          </div>
          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <div class="sub-section-wrapper">
              <span class="page-title" style="text-align: center;"> User Details </span>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Contractor Name:</span>
                <input type="text" formControlName="contractorName" maxlength="50" class="form-control margin-top-8"
                  placeholder="Select">
                <span class="error-msg-colour"
                  *ngIf="CSForm.get('contractorName').value && !CSForm.get('contractorName').value">This data is not
                  available in the system. Please contact admin to update these details</span>
              </div>
              <div class="sub-section-wrapper" >
                <span class="section-sub-title" style="width:70px;">Base Unit:<span class="mandatory">*</span></span>
                <p-tree [value]="unitTree" selectionMode="single" (onNodeSelect)="nodeSelected($event)"
                  [(selection)]="selectedUnit"></p-tree> 
                <span class="error-msg-colour"
                *ngIf="csForm.submitted && CSForm.get('BaseUnit').hasError('required')">Please select Base Unit </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Contract Number:<span class="mandatory">*</span></span>
                <!-- <input type="text" maxlength="50" value="" class="form-control margin-top-10" id="name"
                formControlName="ContractNumber" placeholder="Contract Number"> -->
                <p-dropdown [options]="contracts" formControlName="Contract" placeholder="Select" [style]="{'width':'100%'}"
                (onChange)="checkHolder($event)" >
                </p-dropdown>
                <span class="error-msg-colour"
                  *ngIf="csForm.submitted && CSForm.get('Contract').hasError('required')">Please select Contract </span>
                  <span class="error-msg-colour"
                  *ngIf="!isHasContractDetails">Contract Holder is not available for this contract. Please contact admin to update these details. 
                </span>
              </div>
              <div class="sub-section-wrapper">
                <span class="section-sub-title">Reported Month:<span class="mandatory">*</span></span>
                <p-calendar hourFormat="12" [showIcon]="true"
                  [showTime]="false" readonlyInput="true" appendTo="body"
                  hideOnDateTimeSelect="true" formControlName="StatDate" monthNavigator="true" yearNavigator="true"
                  yearRange="1950:2100" view="month" dateFormat="mm/yy" [yearNavigator]="true">
                </p-calendar><div class="clearfix"></div>
                <span class="error-msg-colour"
                *ngIf="csForm.submitted && CSForm.get('StatDate').hasError('required')">Please select Date </span>
              </div>
            </div>

            <span class="page-title" style="text-align: center;"> Elements </span>

            <span class="section-title"> HSSE Pro-active tools </span>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Safety observations not reported in ARA QHSSE Application :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50"  [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="SafetyObsNotReported" />
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Hazards Hunt/HSE Tour Conducted : </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="HazardsTourConducetd" />
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Percentage of HSE training compliance  :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50"  [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="TrainingCompliance" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('TrainingCompliance').hasError('required') && csForm.submitted">Please Enter Percentage of HSE training compliance</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Percentage of fitness to work compliance  :
                <span class="mandatory">*</span> </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="FitnessToWork" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('FitnessToWork').hasError('required') && csForm.submitted">Please Enter Percentage of fitness to work compliance</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Total Emergency Drills Completed  :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="EmergencyDrills" />
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Inspections & Audits Completed  :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="InspectionsAudits" />
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Management site visit by Contractor Management (Operations, HSE etc.)  :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50"  [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="VisitsByContractor" />
            </div>

            <span class="section-title"> Man-hours & Kilometers Driven </span>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Manhours  :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="Manhours" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('Manhours').hasError('required') && csForm.submitted">Please Enter Number of Manhours</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('Manhours').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
                </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                People on board - Contractor :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="PeopleOnBoardContractor" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('PeopleOnBoardContractor').hasError('required') && csForm.submitted">Please Enter People on board - Contractor</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('PeopleOnBoardContractor').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                People on board - Sub-contractors :
                <span class="mandatory">*</span> </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="PeopleOnBoardSubContractor" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('PeopleOnBoardSubContractor').hasError('required') && csForm.submitted">Please Enter People on board - Sub-contractors</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('PeopleOnBoardSubContractor').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of light vehicles :
                <span class="mandatory">*</span> </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="LightVehicles" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('LightVehicles').hasError('required') && csForm.submitted">Please Enter Number of light vehicles</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('LightVehicles').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Kilometers Driven by light vehicles :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="KMLightVehicles" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMLightVehicles').hasError('required') && csForm.submitted">Please Enter Number of Kilometers Driven by light vehicles</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMLightVehicles').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of heavy vehicles :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="HeavyVehicles" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('HeavyVehicles').hasError('required') && csForm.submitted">Please Enter Number of heavy vehicles</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('HeavyVehicles').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Kilometers Driven by heavy vehicles :
                <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="KMHeavyVehicles" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMHeavyVehicles').hasError('required') && csForm.submitted">Please Enter Number of Kilometers Driven by heavy vehicles</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMHeavyVehicles').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of light bus :
                <span class="mandatory">*</span></span> 
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="LightBusses" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('LightBusses').hasError('required') && csForm.submitted">Please Enter Number of light bus</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('LightBusses').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Kilometers Driven by light bus :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="KMLightBusses" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMLightBusses').hasError('required') && csForm.submitted">Please Enter Number of Kilometers Driven by light bus</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMLightBusses').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of heavy bus :
                <span class="mandatory">*</span></span> 
              <div class="clearfix"></div>
              <input type="number" maxlength="50"  [min]="0"class="form-control margin-top-8" placeholder="Select"
                formControlName="HeavyBusses" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('HeavyBusses').hasError('required') && csForm.submitted">Please Enter Number of heavy bus</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('HeavyBusses').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of Kilometers Driven by heavy bus :
                 <span class="mandatory">*</span></span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="KMHeavyBusses" />
              <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMHeavyBusses').hasError('required') && csForm.submitted">Please Enter Number of Kilometers Driven by heavy bus</span>
                  <span class="error-msg-colour" *ngIf="
                  CSForm.get('KMHeavyBusses').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
          </div>    

          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12 statistics-production">
            <span class="page-title" style="text-align: center;"> Environmental Statistics </span>
            <span class="section-title"> Natural Gas Production, Utilization and Disposal </span>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Total Gas Production (m3/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="NaturalGasProd" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <!-- Total Gas Production (m3/M) : <input type="text" maxlength="50" class="form-control margin-top-8"
                formControlName="NaturalGasProd" style="width:30%;margin-left:10px;" disabled="true"/> -->
                <label style="width:75%;"> Total Gas Production (m3) : {{CSForm.controls.NaturalGasProd.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(NaturalGasProduction,1)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowNaturalGasProduction" scrollHeight="200px" [value]="NaturalGasProduction" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('NaturalGasProduction')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,NaturalGasProduction,1,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">      
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'NaturalGasProduction')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                <!-- <input type="button" class="btn btn-link" (click)="addLocationRecord('NaturalGasProduction')" value="Add Record"> -->
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Fuel Gas - Generators (m3) : {{CSForm.controls.FuelGasGenerators.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableFuelGasGenerators,2)" value="Add Record">  
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableFuelGasGenerators" scrollHeight="200px" [value]="TableFuelGasGenerators" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableFuelGasGenerators')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableFuelGasGenerators,2,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableFuelGasGenerators')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
            
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Fuel Gas - Heater Treater (m3/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="FuelGasTreater" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">     
                <label style="width:75%;"> Fuel Gas - Heater Treater (m3) : {{CSForm.controls.FuelGasTreater.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableFuelGasTreater,3)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableFuelGasTreater" scrollHeight="200px" [value]="TableFuelGasTreater" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableFuelGasTreater')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableFuelGasTreater,3,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableFuelGasTreater')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
               
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                All Gas Flared (m3/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="AllGasFlared" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> All Gas Flared (m3) : {{CSForm.controls.AllGasFlared.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableAllGasFlared,4)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableAllGasFlared" scrollHeight="200px" [value]="TableAllGasFlared" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableAllGasFlared')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableAllGasFlared,4,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableAllGasFlared')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <span class="section-title"> Produced Water Management </span>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Total Produced Water (m3/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="TotalProducedWater" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Total Produced Water (m3) : {{CSForm.controls.TotalProducedWater.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableTotalProducedWater,5)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableTotalProducedWater" scrollHeight="200px" [value]="TableTotalProducedWater" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableTotalProducedWater')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableTotalProducedWater,5,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableTotalProducedWater')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
       
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                PW Re-Injected (m3/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="PWReInjected" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> PW Re-Injected (m3) : {{CSForm.controls.PWReInjected.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TablePWReInjected,6)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTablePWReInjected" scrollHeight="200px" [value]="TablePWReInjected" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TablePWReInjected')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TablePWReInjected,6,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TablePWReInjected')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                PW Evaporated (m3/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="PWEvaporated" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> PW Evaporated (m3): {{CSForm.controls.PWEvaporated.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TablePWEvaporated,7)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTablePWEvaporated" scrollHeight="200px" [value]="TablePWEvaporated" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TablePWEvaporated')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TablePWEvaporated,7,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TablePWEvaporated')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Water Abstracted for Water Injection (BBLS/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="WaterAbstracted" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Water Abstracted for Water Injection (BBLS): {{CSForm.controls.WaterAbstracted.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableWaterAbstracted,8)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableWaterAbstracted" scrollHeight="200px" [value]="TableWaterAbstracted" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableWaterAbstracted')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableWaterAbstracted,8,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableWaterAbstracted')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>

            <span class="section-title"> Diesel Use </span>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                EPF DGS (Liters/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="EPFDGS" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> EPF DGS (L) : {{CSForm.controls.EPFDGS.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableEPFDGS,9)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableEPFDGS" scrollHeight="200px" [value]="TableEPFDGS" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableEPFDGS')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableEPFDGS,9,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableEPFDGS')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Camp DGS (Liters/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="CampDGS" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Camp DGS (L) : {{CSForm.controls.CampDGS.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableCampDGS,10)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableCampDGS" scrollHeight="200px" [value]="TableCampDGS" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableCampDGS')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableCampDGS,10,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableCampDGS')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
               
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Contractor DGS (Liters/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="ContractorDGS" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Contractor DGS (L) : {{CSForm.controls.ContractorDGS.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableContractorDGS,11)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableContractorDGS" scrollHeight="200px" [value]="TableContractorDGS" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableContractorDGS')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableContractorDGS,11,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableContractorDGS')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Vehicle (Liters/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="Vehicle" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Vehicle (L) : {{CSForm.controls.Vehicle.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableVehicle,12)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableVehicle" scrollHeight="200px" [value]="TableVehicle" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableVehicle')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableVehicle,12,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableVehicle')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
               
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Stationary Sources (L) : {{CSForm.controls.StationarySource.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableStationarySource,13)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableStationarySource" scrollHeight="200px" [value]="TableStationarySource" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableStationarySource')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableStationarySource,13,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableStationarySource')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Generators (L) : {{CSForm.controls.Generators.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableGenerators,14)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableGenerators" scrollHeight="200px" [value]="TableGenerators" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableGenerators')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableGenerators,14,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableGenerators')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
               
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Wells DGS (Liters/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="WellsDGS" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Wells DGS (L) : {{CSForm.controls.WellsDGS.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableWellsDGS,15)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableWellsDGS" scrollHeight="200px" [value]="TableWellsDGS" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableWellsDGS')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableWellsDGS,15,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableWellsDGS')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>                
            </div>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Other (Liters/M) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="Other" />
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Other (L) : {{CSForm.controls.Other.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableOther,16)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableOther" scrollHeight="200px" [value]="TableOther" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableOther')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableOther,16,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableOther')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>

            <span class="section-title"> Portable Water </span>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Water Consumption (M3) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="WaterConsumption" />
            </div>

            <span class="section-title"> Mains Electricity Use (MWh) </span>
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                QAM EPF (MWh) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" class="form-control margin-top-8" placeholder="Select"
                formControlName="MainsElectricity" />
            </div> -->
           <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> EPF : {{CSForm.controls.MainsElectricity.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableMainsElectricity,17)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableMainsElectricity" scrollHeight="200px" [value]="TableMainsElectricity" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableMainsElectricity')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableMainsElectricity,17,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableMainsElectricity')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>               
            </div> 
            <!-- <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> EPF : {{CSForm.controls.MainsElectricityEPF.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableMainsElectricityEPF,18)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableMainsElectricityEPF" scrollHeight="200px" [value]="TableMainsElectricityEPF" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableMainsElectricityEPF')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableMainsElectricityEPF,18,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableMainsElectricityEPF')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>               
            </div> -->
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Camp : {{CSForm.controls.MainsElectricityCamp.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableMainsElectricityCamp,19)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableMainsElectricityCamp" scrollHeight="200px" [value]="TableMainsElectricityCamp" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableMainsElectricityCamp')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableMainsElectricityCamp,19,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableMainsElectricityCamp')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20" style="display:inline-flex">
                <label style="width:75%;"> Wells : {{CSForm.controls.MainsElectricityWells.value}}</label>
                <input type="button" style="padding:0;" class="btn btn-link" (click)="addLocationRecord(TableMainsElectricityWells,20)" value="Add Record">
              </span>
                <p-table [scrollable]="true" *ngIf="ShowTableMainsElectricityWells" scrollHeight="200px" [value]="TableMainsElectricityWells" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 40px;">Sr. No</th>
                      <th style="width: 80px;">Quantity</th>
                      <th style="width: 100px;">Location</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 40px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 80px;">
                         <input type="number" maxlength="5" min="0" (input)="onRowChange('TableMainsElectricityWells')" class="form-control margin-top-8" placeholder="Select" [(ngModel)]="record.Quantity" [ngModelOptions]="{standalone: true}"/> 
                         <div *ngIf="(!record.Quantity || record.Quantity <= 0 || record.Quantity == '0') && record.ShowQuantityErrorMessage">
                          <span class="error-msg-colour">Quantity cannot be left blank or 0 or negative</span>
                        </div> 
                      </td>
                      <td style="width: 100px;">
                         <select class="form-control" value="0" [(ngModel)]="record.LocationId" (change)="onLocationChange(ri,TableMainsElectricityWells,20,record.Quantity)" 
                         [ngModelOptions]="{standalone: true}">         
                         <option *ngFor="let loc of locations" value={{loc.Value}} [selected]="record.LocationId === loc.Value"
                        >{{loc.Name}}</option> 
                        </select>
                        <div *ngIf="(!record.LocationId || record.LocationId == 0 || record.LocationId == '0') && record.ShowLocationIdErrorMessage">
                          <span class="error-msg-colour">Please Select Location</span>
                        </div> 
                      </td> 
                      <td style="width: 25px;">
                        <button pButton pRipple type="button"  icon="pi pi-trash" (click)="onRowDelete(ri,'TableMainsElectricityWells')" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                
            </div>
          </div>

          <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
            <span class="page-title" style="text-align: center;"> Waste Consumption </span>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Hazardous waste ( Oily waste) (M3) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="HazardousWasteOily" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('HazardousWasteOily').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Hazardous waste ( Chemical waste) (M3) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="HazardousWasteChemical" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('HazardousWasteChemical').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Hazardous waste ( Drilling waste) (M3) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50"  [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="HazardousWasteDrilling" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('HazardousWasteDrilling').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Hazardous waste ( Other Waste ) (M3) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="HazardousWasteOther" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('HazardousWasteOther').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Non-Hazardous ( Scrap metal ) (KG) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="NonHazardScrap" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('NonHazardScrap').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Non-Hazardous ( Wood scrap) (KG) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="NonHazardWood" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('NonHazardWood').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Non-Hazardous ( Plastic Scrap) (KG) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="NonHazardPlastic" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('NonHazardPlastic').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Non-Hazardous (Domestic / Office) (KG) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="NonHazardDomestic" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('NonHazardDomestic').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Non-Hazardous (Kitchen) (KG) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="NonHazardKitchen" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('NonHazardKitchen').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Amount Sewage water (Gallon) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="SewageWater" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('SewageWater').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                OBM Disp (M3) :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="OBMDisp" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('OBMDisp').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Number of consignment note :
                </span>
              <div class="clearfix"></div>
              <input type="number" maxlength="50" [min]="0" class="form-control margin-top-8" placeholder="Select"
                formControlName="NumOfConsignmentNote" />
                <span class="error-msg-colour" *ngIf="
                  CSForm.get('NumOfConsignmentNote').hasError('min') && csForm.submitted">Negative values are not allowed.</span>
            </div>
            <div class="sub-section-wrapper">
              <span class="section-sub-title margin-right-20">
                Upload Support Evidence :
                </span>
                <p-table [scrollable]="true" scrollHeight="300px" [value]="supportEvidence" dataKey="id" editMode="row">
                  <ng-template pTemplate="header">
                    <tr>
                      <th style="width: 25px;">Sr. No</th>
                      <th style="width: 100px;">Document Name</th>
                      <th style="width: 100px;">Documents</th>
                      <th style="width: 20px;"></th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-record let-editing="editing" let-ri="rowIndex">
                    <tr [pEditableRow]="record">
                      <td style="width: 20px;">
                        {{ri+1}}
                      </td>
                      <td style="width: 100px;">
                        <textarea type="text" [(ngModel)]="record.description" [ngModelOptions]="{standalone: true}" maxlength="50" class="margin-top-8"></textarea>
                      </td>
                      <td style="width: 100px;">
                        <ara-file-upload 
                        [mode]="'basic'"
                        [inputFiles]="record.files" (onInputFilesUpdatedData)="onInputFilesUpdated($event,ri)"></ara-file-upload>
                        <ara-files-previewer *ngIf="isUpdate" [files]="record.files"></ara-files-previewer>
                      </td>
                      <td style="width: 25px;">
                        <button pButton pRipple type="button" icon="pi pi-trash" (click)="onRowDeleteInit(ri)" class="p-button-rounded p-button-text"></button>
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
                <input type="button" class="btn btn-link" (click)="addRecord()" value="Add Record">
            </div>
            <div *ngIf="isApprovalSectionShow" class="statistic-approval">
              <span class="page-title" style="text-align: center;"> Approval </span>
              <div class="section-sub-title sub-section-wrapper">
                <div>Approver:  {{approverName}}</div>
                <div *ngIf="isApprovedReject">{{ApprovedRejectedDate}}: {{approvedRejectedDate | dateTimeFormat: "MMM D, YYYY h:mm a"}}</div>
                <div>Status: {{statRequest.StatusName}}</div>
              </div>
              <div>
                <textarea placeholder="Remarks" formControlName="RejectRemark" [maxLength]="1000" class="margin-left-10 align-textarea"></textarea>
              </div>
              <div class="sub-section-wrapper">
                <input type="button" class="btn btn-primary" [(disabled)] = "IsApproveDisable"
                (click)="saveApproval('Approve')" value="Approve">
                <input type="button" style="margin-left: 10px;" class="btn btn-primary" [(disabled)] = "IsRejectDisable"
                (click)="saveApproval('Reject')" value="Reject">
              </div>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="breaker"></div>
          <footer>
            <p-footer>
              <ara-record-actions class="pull-left" *ngIf="statisticId>0" [SourceId]="statisticId" ModuleName="ContractorStatistics"
                [ShowCancel]="((permissions.PD_Admin || permissions.PD_Admin_Unit || independentPermissions.SUPER_Admin) && statusName !=='Deleted') && statusName !=='Cancelled'"
                [ShowDelete]="independentPermissions.SUPER_Admin && statusName !=='Cancelled' && statusName !=='Deleted'" [Status]="statusName"
                [ShowRestate]="(permissions.PD_Admin || permissions.PD_Admin_Unit) && statusName==='Cancelled'"
                (output)="getOutput($event)"></ara-record-actions>
              <button type="button"
                *ngIf="statisticId > 0"
                (click)="ReportshowDialog()"
                class="btn btn-primary primary-btn button-report-log button-float-left"
                 >Report Log
              </button>  
              <button type="submit" class="btn btn-primary primary-btn button-draft" (click)="saveAsDraft('Draft')" *ngIf="
						   (statisticId === 0 || statusName === 'Draft')">
					    <i class="fa fa-envelope"></i>Save As Draft</button>	
              <button [disabled] = "isResetDisable" role="button" class="btn btn-primary primary-btn button-reset" (click)="ResetForm()">
                <i class="fa fa-refresh"></i>Reset
              </button>
              <button *ngIf="isUpdate" role="button" class="btn btn-primary primary-btn button-pdf" (click)="downloadPDF()">
                <i class="fa fa-file-pdf-o"></i>DOWNLOAD PDF
              </button>
              <button *ngIf="isUpdate && statusName !== 'Draft'" [disabled]="isUpdateDisable"
                type="submit" pButton label="UPDATE" (click)="submitUpdateStatistics('Update')"
                class="btn btn-primary primary-btn button-update"><i class="fa fa-share-square"></i></button>
               <button *ngIf="(!isUpdate || statusName === 'Draft')"
                type="submit" pButton label="SUBMIT" (click)="submitUpdateStatistics('Submit')"
                class="btn btn-primary primary-btn button-submit"><i class="fa fa-share-square"></i></button>
                
            </p-footer>
          </footer>
        </div>
      </div>
      <div class="clearfix"></div>
    </div>
  </div>
  <div class="clearfix"></div>
</form>

<ara-alerts [alertType]="alertType" [successDetails]="successDetails" [errorDetails]="errorDetails"
  (okClicked)="onOkClickedForConfirmation()" [confirmMessage]="confirmMessage"
  (yesClicked)="onYesClickedForConfirmation()" (noClicked)="onNoClickedForConfirmation()"></ara-alerts>
<div class="clearfix"></div>
<span *ngIf="ReportclosePopup">
  <p-dialog header="Report History"  [(visible)]="ReportclosePopup" (onHide)="ReportclosePopUp()" [modal]="true" >
   <ara-report-log [ReportUserId]="ReportUserId" [ReportModule]="ReportModule"
     [ReportRecordId]="ReportRecordId" >
   </ara-report-log>
 </p-dialog> 
</span>
